"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGeolocationProperty = exports.geolocationPropertyDefinition = void 0;
exports.geolocationPropertyDefinition = {
    view: {
        label: 'Geolocation',
        style: '',
        hint: 'Where is this taking place?',
    },
    constraints: [
        {
            name: 'stencils',
            argument: [
                'country',
                'geolocation',
                'virtual-geolocation',
                'worldwide-geolocation',
            ],
        },
    ],
    type: 'asset',
    multiple: false,
    name: 'geolocation',
};
const isGeolocationProperty = (prop) => {
    return prop.name === exports.geolocationPropertyDefinition.name;
};
exports.isGeolocationProperty = isGeolocationProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2VvbG9jYXRpb24ucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9nZW9sb2NhdGlvbi5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLDZCQUE2QixHQUFHO0lBQzNDLElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxhQUFhO1FBQ3BCLEtBQUssRUFBRSxFQUFFO1FBQ1QsSUFBSSxFQUFFLDZCQUE2QjtLQUNwQztJQUNELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFO2dCQUNSLFNBQVM7Z0JBQ1QsYUFBYTtnQkFDYixxQkFBcUI7Z0JBQ3JCLHVCQUF1QjthQUN4QjtTQUNGO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsT0FBTztJQUNiLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLGFBQWE7Q0FDWSxDQUFBO0FBSTFCLE1BQU0scUJBQXFCLEdBQUcsQ0FBQyxJQUFrQixFQUErQixFQUFFO0lBQ3ZGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxxQ0FBNkIsQ0FBQyxJQUFJLENBQUE7QUFDekQsQ0FBQyxDQUFBO0FBRlksUUFBQSxxQkFBcUIseUJBRWpDIn0=